// Flag icons via the flagcdn.com CDN (same source the lab-product picker uses).
// No npm dependency; each flag is an SVG keyed by ISO-3166-1 alpha-2 country code.

/** Flag SVG URL for an ISO country code (e.g. "gb" → the UK flag). */
export const flagUrl = (countryCode?: string | null): string | undefined => {
  const cc = (countryCode || "").trim().toLowerCase();
  return cc.length >= 2 ? `https://flagcdn.com/${cc.slice(0, 2)}.svg` : undefined;
};

// Language / locale code → the country whose flag best represents it. Legacy
// stores locale ids like "en", "ms-my", "pt"; we map them to a flag country.
const LANG_COUNTRY: Record<string, string> = {
  en: "gb",
  de: "de",
  fr: "fr",
  nl: "nl",
  es: "es",
  it: "it",
  pt: "pt",
  br: "br",
  no: "no",
  th: "th",
  ja: "jp",
  ms: "my",
  "ms-my": "my",
  al: "al",
  bg: "bg",
  mx: "mx",
  zh: "cn",
  pl: "pl",
  sv: "se",
  da: "dk",
  fi: "fi",
  ru: "ru",
  ar: "sa",
  tr: "tr",
  ko: "kr",
};

/** Flag SVG URL for a language / locale code. */
export const langFlagUrl = (lang?: string | null): string | undefined => {
  const key = (lang || "").trim().toLowerCase();
  if (!key) return undefined;
  const cc = LANG_COUNTRY[key] || LANG_COUNTRY[key.split("-")[0]] || key.split("-")[0];
  return flagUrl(cc);
};

const LANG_NAMES: Record<string, string> = {
  en: "English",
  de: "German",
  fr: "French",
  nl: "Dutch",
  es: "Spanish",
  it: "Italian",
  pt: "Portuguese",
  br: "Portuguese (BR)",
  no: "Norwegian",
  th: "Thai",
  ja: "Japanese",
  ms: "Malay",
  "ms-my": "Malay",
  al: "Albanian",
  bg: "Bulgarian",
  mx: "Spanish (MX)",
};

/** Human-readable language name for a locale code (falls back to the code). */
export const langName = (code?: string | null): string => {
  const k = (code || "").trim().toLowerCase();
  return LANG_NAMES[k] || LANG_NAMES[k.split("-")[0]] || (code || "").toUpperCase();
};
